module.exports = __webpack_public_path__ + "121103b893f0e9f7bf81c4c687898159.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/age.svg
// module id = 75
// module chunks = 0